import { render, staticRenderFns } from "./RouteDesigns.vue?vue&type=template&id=585e8a3c&scoped=true&"
import script from "./RouteDesigns.vue?vue&type=script&lang=js&"
export * from "./RouteDesigns.vue?vue&type=script&lang=js&"
import style0 from "./RouteDesigns.vue?vue&type=style&index=0&id=585e8a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e8a3c",
  null
  
)

export default component.exports